<template lang="pug">
  md-dialog(:md-active.sync="showErrorDialog" @md-closed="$emit('close-dialog', $event)")
    md-dialog-title Error
    md-dialog-content {{errorDialogMessage}}
    md-dialog-actions
      md-button.md-accent.md-raised(@click="$emit('confirm-dialog', $event)") Ok
</template>

<script>
export default {
  props: {
    showErrorDialog: {
      type: Boolean,
      default: false
    },
    errorDialogMessage: {
      type: String,
      default: 'Error!!'
    }
  }
}
</script>
